<template>
    <SubmenuGrid :items="items" :show-count="false" />
</template>

<script>
import SubmenuGrid from "@/components/SubmenuGrid";

export default {
    name: "PortalStudentReportMenuvueSubmenu",
    components: { SubmenuGrid },
    data() {
        return {
            items: [
            {
                to: "/student/report-card-full-term",
                title: "Report Card (Full Term)",
                description: "Review academic results and grades for the full term.",
                icon: "fa fa-folder"
            },
            {
                to: "/student/report-card-mid-term",
                title: "Report Card (Mid Term)",
                description: "Review academic progress and grades at mid-term.",
                icon: "fa fa-folder"
            },
            {
                to: "/student/exam",
                title: "Mock Report",
                description: "Review student results from mock examinations.",
                icon: "fa fa-folder"
            }
            ]
        };
    }
};
</script>
